import type { IBaseForm } from "@/types/general";

export default function generateSearchBankForm(): IBaseForm {
  return {
    search: {
      props: {
        placeholder: "Kasa adı yazınız",
        fluid: true,
        size: "large",
        inputType: "text",
        maxlength: "40",
      },
      key: "search",
      required: true,
      value: "",
    },
  };
}
